import { useI18nLanguage } from "@hooks/useI18nLanguage";
import { useAppDispatch, useAppSelector } from "../hooks/redux";
import { queryMembership, updateDeviceId } from "@store/globalSlice";
import { initDeviceId } from "@utils/util";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { broadcastManager } from "@hooks/broadcastManager";

// 初始化设备信息
const useInitDevice = () => {
  const location = useLocation();
  const dispatch = useAppDispatch();

  useEffect(() => {
    (async function () {
      const deviceId = await initDeviceId();
      if (deviceId) {
        dispatch(updateDeviceId(deviceId as string));
      }
    })();
  }, [location]);
};

export const useFetchMembershop = () => {
  const { region, isLogin } = useAppSelector((state) => state.globalReducer);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (isLogin) {
      dispatch(queryMembership({ country: region }));
    }
  }, [isLogin, region]);
};

export const useInitApp = () => {
  const { language } = useAppSelector((state) => state.globalReducer);
  useI18nLanguage(language);

  useInitDevice();

  useEffect(() => {
    window.performance.setResourceTimingBufferSize(1000);
    performance.onresourcetimingbufferfull = () => {
      window.performance.clearResourceTimings();
    };
  }, []);

  useEffect(() => {
    const tabIdForName = location.pathname + "&&" + Math.random().toString(36).substring(2, 15);
    window._TAB_BROADCAST_MANAGER_NAME_ = tabIdForName;

    broadcastManager.init();

    broadcastManager.on("refresh", (data) => {
      // 检查消息是否包含发送者标签页ID
      if (data && data.windowName) {
        // 如果消息来自其他标签页，则刷新
        if (data.windowName !== window._TAB_BROADCAST_MANAGER_NAME_) {
          console.log(`[标签页] 收到来自其他标签页(${data.windowName})的刷新请求，当前标签页(${tabIdForName})将刷新`);
          window.location.reload();
        } else {
          console.log(`[标签页] 忽略来自当前标签页的刷新请求`);
        }
      } else {
        console.log(`[标签页] 收到无标识的刷新请求，无法判断来源`);
      }
    });

    return () => {
      broadcastManager.destroy();
    };
  }, []);
};

export const useIsVersionV2 = () => {
  const paths = [
    "/creator",
    "/video",
    "/shop",
    "/livestream",
    "/product",
    "/category",
    "/creator/detail",
    "/shop/detail",
    "/video/detail",
    "/livestream/detail",
    "/product/detail",
    "/overview/category",
    "/category/detail",
  ];
  const isVersionV2 = paths.includes(location.pathname);
  return { isVersionV2 };
};
